import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module";
import { NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap/timepicker/timepicker.module";
import { TenantsModel } from ".";
import { FieldValueModel } from "./field-value-model";
import { IncidentGuardModel } from "./incident-guard-model";
import { ReportModel } from "./report-model";
import { Type1Model } from "./type1-model";
import { Type2Model } from "./type2-model";
import { Type3Model } from "./type3-model";

export class IncidentModel {
    public Id: number;
    public Time: Date;
    public TimeHour: NgbTimeStruct;
    public TimeDate: NgbDateStruct;
    public TimeDates: NgbDateStruct[];
    public Quantity: number;
    public PoliceResponse: string;

    public ActionDescription: string;

    public Type1Id: number;
    public Type1: Type1Model;

    public Type2Id: number;
    public Type2: Type2Model;

    public Type3Id: number;
    public Type3: Type3Model;

    public TenantId: number;
    public Tenant: TenantsModel;

    public IncidentGuard: IncidentGuardModel[];
    public Reports: ReportModel[];
    public TimeZoneOffset: number;

    public AccountId: number;
    public SiteId: number;

    public IsDeleted: boolean;

    public SendReport: boolean;

    public WithBlueLight: boolean;
    public BlueLightOption: string;

    public Latitude: string
    public Longitude: string

    public FromScan: boolean;

    // UPDATE 15012019
    public FieldValues: FieldValueModel[];

    public DeletedImages: string[]
    public Images: string[]

    public FromWeb: boolean = true
    
    public CreatedDate: any;
    public UpdatedDate: any;

    public CreatedBy: number;
    public UpdatedBy: number;
}

export class ReportEmailModel {

    public recepients: string[];
    public base64: string;
    public EmailTitle: string;
    public routineName: string;
    public siteId: number;
    public IncidentId: number;
    public ReportTypeId: number;
    public Date1: NgbDateStruct;
    public Date2: NgbDateStruct;
    public SenderName: string;

}



// WEBPACK FOOTER //
// ./src/app/models/incident-model.ts